export const defaultTransitionFunctionTokens = {
    'twist-ease-1': 'cubic-bezier(0.25, 0, 0.5, 1)',
    'twist-ease-2': 'cubic-bezier(0.25, 0, 0.4, 1)',
    'twist-ease-3': 'cubic-bezier(0.25, 0, 0.3, 1)',
    'twist-ease-4': 'cubic-bezier(0.25, 0, 0.2, 1)',
    'twist-ease-5': 'cubic-bezier(0.25, 0, 0.1, 1)',
    'twist-ease-in-1': 'cubic-bezier(0.25, 0, 1, 1)',
    'twist-ease-in-2': 'cubic-bezier(0.5, 0, 1, 1)',
    'twist-ease-in-3': 'cubic-bezier(0.7, 0, 1, 1)',
    'twist-ease-in-4': 'cubic-bezier(0.9, 0, 1, 1)',
    'twist-ease-in-5': 'cubic-bezier(1, 0, 1, 1)',
    'twist-ease-out-1': 'cubic-bezier(0, 0, 0.75, 1)',
    'twist-ease-out-2': 'cubic-bezier(0, 0, 0.5, 1)',
    'twist-ease-out-3': 'cubic-bezier(0, 0, 0.3, 1)',
    'twist-ease-out-4': 'cubic-bezier(0, 0, 0.1, 1)',
    'twist-ease-out-5': 'cubic-bezier(0, 0, 0, 1)',
    'twist-ease-in-out-1': 'cubic-bezier(0.1, 0, 0.9, 1)',
    'twist-ease-in-out-2': 'cubic-bezier(0.3, 0, 0.7, 1)',
    'twist-ease-in-out-3': 'cubic-bezier(0.5, 0, 0.5, 1)',
    'twist-ease-in-out-4': 'cubic-bezier(0.7, 0, 0.3, 1)',
    'twist-ease-in-out-5': 'cubic-bezier(0.9, 0, 0.1, 1)'
};
export const defaultTransitionDurationTokens = {
    'twist-duration-0': '0s',
    'twist-duration-50': '50ms',
    'twist-duration-100': '100ms',
    'twist-duration-150': '150ms',
    'twist-duration-200': '200ms',
    'twist-duration-400': '400ms',
    'twist-duration-800': '800ms',
    'twist-duration-1000': '1000ms'
};
